import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from '../reducers/system-configuration.reducer';

export const selectSystemConfigurationState = createFeatureSelector<State>('systemConfiguration');

export const getGeneralInformation = createSelector(
  [selectSystemConfigurationState],
  (state: State, product: string) => {
    return state.generalInformationMap.get(product);
  }
);

export const selectApplicationName = createSelector(
  [selectSystemConfigurationState],
  (state: State, product: string) => {
    const generalInfo = state.generalInformationMap.get(product);
    if (generalInfo && generalInfo.applicationName) {
      return generalInfo.applicationName;
    } else {
      return null;
    }
  }
);

export const getSystemConfigurationLoading = createSelector(
  [selectSystemConfigurationState],
  (state: State) => {
    return state.loading;
  }
);

export function getApplicationName() {
  return selectApplicationName;
}
